import { LANGUAGE_KEY, LANGUAGE_SESSION, selectIsLoggedIn, updateLanguage } from 'containers/Login/loginSlice'
import { selectFilters } from 'containers/Maps/menu/filtersSlice'
import { fetchMapLocations } from 'containers/Maps/Map/mapSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import { saveState } from 'utils/storage'
import { getConfig } from 'appSlice'
import { PATCH } from 'rest/request'
import { user } from 'rest/urls'

type Language = 'pl' | 'en'

const useLanguage = () => {
  const filters = useReduxSelector(selectFilters)
  const isLoginIn = useReduxSelector(selectIsLoggedIn)
  const dispatch = useReduxDispatch()
  const sendLanguage = async (language: Language) => {
    try {
      await PATCH(user, { body: { language } })
    } catch (error) { }
  }

  const changeLanguage = (language: Language) => {
    dispatch(updateLanguage(language))
    dispatch(getConfig())
    dispatch(fetchMapLocations({ body: filters }))
    if (isLoginIn) {
      sendLanguage(language)
    } else {
      saveState(language, LANGUAGE_SESSION, LANGUAGE_KEY)
    }
  }

  return changeLanguage
}

export default useLanguage